import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import MediaDetails from "../../components/admincomponents/MediaDetails";

function ViewMedia({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <MediaDetails />            
    </>
  );
}

export default ViewMedia;
